import { TTerminalError } from "@/types/TTerminal";

export class TerminalError extends Error implements TTerminalError {
	public data?: unknown;

	constructor(message: string, data?: unknown) {
		super(message);
		this.name = "TerminalError";
		this.data = data;

		// Nécessaire pour que l'instance soit correctement configurée en tant que sous-classe d'Error
		Object.setPrototypeOf(this, TerminalError.prototype);
	}
}
